module.exports = __webpack_public_path__ + "img/level2addon_mining_tool.2e6d2aba.png";